<template>
  <view
    class="a-flex a-ai-c a-jc-c a-bg-#F85A5B a-c-#fff a-fw-500"
    :style="{
      width: width + 'rpx',
      height: height + 'rpx',
      lineHeight: height + 'rpx',
      borderRadius: borderRadius + 'rpx',
      fontSize: fontSize + 'rpx',
    }"
    >{{ btnText }}
  </view>
</template>

<script>
import lineIndexMixins from '@/pages/index2.0/mixins/lineIndexMixins.js';
import checkEnterHotelWriteMinxins from '@/pages/product3.0/mixins/hotel/checkEnterHotelWrite.js';
import { ValidateLastTrainOrderUserType } from '@/api/train/train.js';
import get from 'lodash-es/get';
import dayjs from 'dayjs';
import standardHandle from '@/common/lineIndex/handle.js';
import mdate from '@/common/momentHandle.js';

export default {
  mixins: [lineIndexMixins, checkEnterHotelWriteMinxins],
  name: 'BookBtn',
  props: {
    width: {
      type: Number,
      default: 36,
    },
    height: {
      type: Number,
      default: 36,
    },
    borderRadius: {
      type: Number,
      default: 4,
    },
    fontSize: {
      type: Number,
      default: 24,
    },
    // 业务线
    productType: {
      type: Number,
      default: 1,
    },
    isInternational: {
      // 是否国际
      type: Boolean,
      default: false,
    },
    //产品信息
    productInfo: {
      type: Object,
      default: () => {},
    },
    // 是否使用缓存的日期-业务线首页的组件会用
    isUseCacheDate: {
      type: Boolean,
      default: false,
    },
    startDate: {
      type: String,
      default: '',
    },
    btnText: {
      type: String,
      default: '订',
    },
  },
  data() {
    return {
      IsTravelBussiness: 1,
      traindetailData: {},
      result: {
        code: '',
        msg: '',
        IsNeedPhone: 0,
      },
    };
  },
  mounted() {},
  methods: {
    handleBtnBook() {
      let settings = this.$app.GetSettings();
      this.IsTravelBussiness = settings.bookingMethod;
      // 验证是否绑定支付宝
      if (this.IsTravelBussiness === 1) {
        if (!this.checkNeedBindALiPay()) {
          return;
        }
      }

      // 验证是否可以使用
      if (!standardHandle.getBusinessCanUsed(this.productType, this.isInternational)) {
        return;
      }
      switch (this.productType) {
        case 1: {
          this.checkHotelEnterWritePage(this.productInfo, this.isUseCacheDate); // 验证酒店进入填单页
          break;
        }
        case 5: {
          const settings = this.$app.GetSettings();
          const today = mdate.getCurrentTime();
          const departDate = get(settings, 'DepartDateFlightJson.fulldate', today);
          const startDate = this.startDate ? this.startDate : departDate;
          const departureDateFull = dayjs(startDate).isBefore(today) ? today : startDate;
          const arrivalDateFull = dayjs(departureDateFull).add(1, 'day').format('YYYY-MM-DD');
          const flightOftenInfo = { ...this.productInfo, departureDateFull, arrivalDateFull };
          settings.dcFlightParams = {
            ...settings.dcFlightParams,
            OrgCity: flightOftenInfo.departureCityName || '',
            DstCity: flightOftenInfo.arrivalCityName || '',
            DepartDate: flightOftenInfo.departureDateFull,
          };
          settings.depAddressData = { ...settings.depAddressData, cityName: flightOftenInfo.departureCityName || '' };
          settings.arrAddressData = { ...settings.arrAddressData, cityName: flightOftenInfo.arrivalCityName || '' };
          this.$dataManager.setCacheData('flightOftenInfo', flightOftenInfo);
          this.$dataManager.setCacheData('settings', settings);
          uni.navigateTo({
            url: `/pages/product3.0/flight/writeOrder/writeOrder?lineType=0&bookType=1`,
          });
          break;
        }
        case 6: {
          this.goTraninWritePage();
          break;
        }
        case 7: {
          let globalData = getApp().globalData;
          globalData.carCommolyUsedData = this.productInfo;
          uni.navigateTo({
            url: '/pages/product3.0/car/index/index?isCommoly=1',
          });
        }
      }
    },
    // 跳转火车票填单页
    async goTraninWritePage() {
      await this.saveTrainParamsData();
      uni.navigateTo({
        url: `/pages/product3.0/train/writeOrder/writeOrder?bookType=1`,
      });
    },
    // 存储火车票数据
    saveTrainParamsData() {
      return new Promise(async (resolve) => {
        const settings = this.$app.GetSettings();
        let systemTime = mdate.getCurrentTime();
        const today = dayjs(systemTime).format('YYYY-MM-DD');
        let CacheDepartDate = get(settings, 'DepartDateTrainJson.fulldate', today);
        CacheDepartDate = dayjs(CacheDepartDate).isBefore(today) ? today : CacheDepartDate;
        const departDate = this.isUseCacheDate ? CacheDepartDate : dayjs(today).add(1, 'day').format('YYYY-MM-DD');
        const arriveDate = dayjs(departDate).add(1, 'day').format('YYYY-MM-DD');
        // // 1.5存储
        // settings.is12306Account = res.TicketModeType === '1';
        // settings.IsChangeRebuy = false;
        // settings.account12306 = res.AccountNo;
        // settings.IsChangeRebuy = res.IsChangeRebuy;
        // 填单页详情接口调用存储
        let trainOftenInfo = {
          ArrCode: this.productInfo.arrivalCode,
          DepCode: this.productInfo.departureCode,
          DepDate: departDate + ' ' + this.productInfo.departureDate,
          TrainId: this.productInfo.mainKey,
          IsTravelBussiness: this.IsTravelBussiness,
          // TicketModel: res.TicketModeType, //1自购 3人工
          arrivalCityName: this.productInfo.arrivalCityName,
          departureCityName: this.productInfo.departureCityName,
        };
        settings.trainParams = trainOftenInfo;

        // 填单页选择常旅用存储-返回业务线首页也用
        let tapDepat = settings.tapDepat || {};
        let tapArrive = settings.tapArrive || {};
        let tapDepatCopy = {
          szm: this.productInfo.departureCode,
          name: this.productInfo.departureInfo,
          cityName: this.productInfo.departureCityName,
          type: 'station',
          isStation: true,
        };
        let tapArriveCopy = {
          szm: this.productInfo.arrivalCode,
          name: this.productInfo.arrivalInfo,
          cityName: this.productInfo.arrivalCityName,
          type: 'station',
          isStation: true,
        };
        settings.tapDepat = { ...tapDepat, ...tapDepatCopy };
        settings.tapArrive = { ...tapArrive, ...tapArriveCopy };

        this.$app.SetSettings(settings);

        // 填单页头部缓存信息存储
        let trainDetailEntity = {
          DepartDate: departDate,
          DepartTimeMD: dayjs(departDate).format('MM月DD日'),
          DepartTimeWeek: mdate.getWeek(departDate, systemTime),
          DepartTimeHM: this.productInfo.departureDate,
          DepartStationName: this.productInfo.departureInfo,
          TrainNo: this.productInfo.mainKey,
          LastTime: this.productInfo.requiredTime,
          ArriveTimeMD: dayjs(arriveDate).format('MM月DD日'),
          ArriveTimeWeek: mdate.getWeek(arriveDate, systemTime),
          ArriveTimeHM: this.productInfo.arrivalDate,
          ArriveStationName: this.productInfo.arrivalInfo,
          seatName: '',
          price: '',
          // 时刻表
          DepartStationCode: this.productInfo.departureCode,
          ArriveStationCode: this.productInfo.arrivalCode,
        };
        let globalData = getApp().globalData;
        globalData.trainDetailEntity = trainDetailEntity;

        this.$store.commit('indexTrain/setTrainIsTransfer', false); //非中转
        resolve();
      });
    },
  },
};
</script>

<style scoped></style>
